import { rootInstance, axiosInstance } from '../axiosConfig';

export interface BannerSlide {
    id: number;
    titulo: string;
    titulo_acento: string;
    color_acento: string;
    descripcion: string;
    tipo: 'image' | 'video';
    imagen: string | null;
    video: string | null;
    video_url: string | null;
    url_imagen: string | null;
    url_video: string | null;
    texto_boton_primario: string;
    texto_boton_secundario: string;
    enlace_boton_secundario: string | null;
    orden: number;
    activo: boolean;
    creado_en?: string;
    actualizado_en?: string;
}

// ── OBTENER SLIDES PÚBLICOS (Para la Landing Page) ──
export const fetchBannerSlidesPublic = async (): Promise<BannerSlide[]> => {
    try {
        const response = await rootInstance.get('banner-slides-public/');
        const data = response.data;
        if (Array.isArray(data)) return data;
        if (data && Array.isArray(data.results)) return data.results;
        return [];
    } catch (err) {
        /* Browser diagnostics omitted. */
        try {
            const fallback = await axiosInstance.get('banner-slides-public/');
            const data = fallback.data;
            if (Array.isArray(data)) return data;
            if (data && Array.isArray(data.results)) return data.results;
            return [];
        } catch (error) {
            /* Browser diagnostics omitted. */
            return [];
        }
    }
};

// ── CRUD PARA SUPER ADMIN ──
export const fetchBannerSlidesAdmin = async (): Promise<BannerSlide[]> => {
    const response = await axiosInstance.get('banner-slides/');
    const data = response.data;
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.results)) return data.results;
    return [];
};

export const createBannerSlide = async (formData: FormData): Promise<BannerSlide> => {
    const response = await axiosInstance.post('banner-slides/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
};

export const updateBannerSlide = async (id: number, formData: FormData): Promise<BannerSlide> => {
    const response = await axiosInstance.patch(`banner-slides/${id}/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
};

export const deleteBannerSlide = async (id: number): Promise<void> => {
    await axiosInstance.delete(`banner-slides/${id}/`);
};

export const reorderBannerSlides = async (items: { id: number; orden: number }[]): Promise<BannerSlide[]> => {
    const response = await axiosInstance.post('banner-slides/reordenar/', items);
    return response.data;
};
